import React, { useState } from "react";
import InputField from "../../shared/InputField";
import AuthLayout from "../AuthLayout";
import { singUp } from "../../../api/authApis";
import { showSuccessToast, showErrorToast } from "../../../utils/Toasts";
import { getParams } from "../../../utils/UrlParams";
import GoogleAuth from "../../shared/GoogleAuth";
import Button from "../../shared/Button";
import hidePassword from "~/images/hide-password.svg";
import showPasswordIcon from "~/images/password-visible.svg";
const App = () => {
  const [form, setForm] = useState({
    first_name: "",
    last_name: "",
    email: "",
    password: "",
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const params = getParams();

  const validate = () => {
    const errs = {};
    if (!form.email) {
      errs.email = "Eamil is required";
    } else if (!/\S+@\S+\.\S+/.test(form.email)) {
      errs.email = "Invalid email format";
    }
    if (!form.password) {
      errs.password = "Password is required";
    } else if (form.password.length < 6) {
      errs.password = "Password must be at least 6 characters";
    }

    return errs;
  };

  const plan= params.plan;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prevForm) => ({
      ...prevForm,
      [name]: value,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (typeof amplitude !== "undefined") {
        amplitude.track("onboarding_signUp_click", {});
      }
    } catch (err) {
      console.warn("Amplitude tracking failed:", err);
    }
    const validationsErrors = validate();
    if (Object.keys(validationsErrors).length === 0) {
      setLoading(true);
      const response = await singUp(form);
      if (response.data.success) {
        showSuccessToast(response.data.message);
        if (response.data.user && Object.keys(params).includes("plan")) {
          window.location.href = `/order?plan=${params.plan}`;
          // const plan = params.plan;
          // let planId = null;
          // if (plan === "solo-monthly") {
          //   planId = gon.paddle_price_starter_id;
          // } else if (plan === "solo-yearly") {
          //   planId = gon.paddle_price_starter_yearly_id;
          // } else if (plan === "freelancer-monthly") {
          //   planId = gon.paddle_price_agency_id;
          // } else if (plan === "freelancer-yearly") {
          //   planId = gon.paddle_price_pro_yearly_id;
          // } else if (plan === "agency-monthly") {
          //   planId = gon.paddle_price_new_agency_id;
          // } else if (plan === "agency-yearly") {
          //   planId = gon.paddle_price_agency_yearly_id;
          // }
          // openCheckout(response.data.user, planId);
        } else {
          window.location.reload();
        }
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        response.data.errors.forEach((error) => {
          showErrorToast(error);
        });
      }
      setLoading(false);
    } else {
      setErrors(validationsErrors);
    }
  };
  // const openCheckout = (user, planId) => {
  //   if (planId) {
  //     const toltReferralId = window.tolt_referral || "";
  //     Paddle.Checkout.open({
  //       settings: { theme: "light" },
  //       customer: {
  //         email: user?.email,
  //       },
  //       customData: {
  //         user_id: user?.id,
  //         tolt_referral: toltReferralId,
  //       },
  //       items: [{ priceId: planId, quantity: 1 }],
  //     });
  //   } else {
  //     window.location.reload();
  //   }
  // };
  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };
  return (
    <AuthLayout>
      <div>
        <div class="text-center mt-[65px] mb-[30px]">
          <h1 class="text-[3rem] font-semibold text-gray-900 system-ui-font">Sign up for Clicks</h1>
          <p class="text-[#7A7A7A] text-[18px] system-ui-font">{plan === "solo-monthly" || plan === "solo-yearly" ? "Start your free 7-day trial" : "Get started risk free with our 7-day money back guarantee."}</p>
        </div>
        <div className="w-[370px] max-[400px]:w-[330px] sm:w-[500px] max-w-full min-h-[420px] bg-white rounded-lg border border-[#ebebeb] py-[45px] px-6 sm:px-[55px] mt-4 mx-auto max-sm:mb-[100px]">
          <GoogleAuth text="Sign up with Google" type="sign-up" />
          <div>
            {/* <h1 className="text-2xl text-center font-semibold mt-5 mb-8">Create Your Account</h1> */}
            <form onSubmit={handleSubmit} noValidate className="mb-6">
              <div className="mb-4">
                <InputField
                  label="Email"
                  labelClasses="!arial-font font-normal !text-[#636363]"
                  name="email"
                  type="email"
                  placeholder="Enter your email"
                  value={form.email}
                  onChange={handleChange}
                  error={errors.email}
                  extraClasses="!bg-[#fbf7f55e] border-gray-200 !rounded-md"
                />
              </div>
              <div className="mb-4">
                <InputField
                  label="Password"
                  labelClasses="!arial-font font-normal !text-[#636363]"
                  name="password"
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter your password"
                  value={form.password}
                  onChange={handleChange}
                  error={errors.password}
                  extraClasses="!bg-[#fbf7f55e] border-gray-200 !rounded-md"
                  icon={
                    showPassword ? (
                      <img src={showPasswordIcon} onClick={togglePasswordVisibility} className="h-[18px] w-[18px] cursor-pointer" />
                    ) : (
                      <img src={hidePassword} onClick={togglePasswordVisibility} className="h-[18px] w-[18px] cursor-pointer" />
                    )
                  }
                />
              </div>
              <Button disabled={loading} type="submit" className="w-full !min-h-[55px] !font-medium  !py-3 !px-4 !text-base !rounded-md">
                {loading ? "Loading..." : plan === "solo-monthly" || plan === "solo-yearly" ? "Create Free Account" : "Create Account"}
              </Button>
            </form>
            <div class="text-center mb-5">
              <span class="">Already have an account? </span>
              <a href="/sign-in" class="text-[#550DF4] underline">
                Login here
              </a>
            </div>
            <p class="text-[11px] text-[#9b9b9b] text-center tracking-tight">
              By clicking "Create Account" above, you acknowledge that you have read and agreed to Clicks' Terms and Conditions and Privacy Policy.
            </p>
          </div>
        </div>
      </div>
    </AuthLayout>
  );
};
export default App;
